import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'getLangForAttrLang',
  standalone: true
})
export class GetLangForAttrLangPipe implements PipeTransform {

  constructor(
    private translateService: TranslateService
  ) { }

  transform(lang: string): string {
    return lang ? lang : this.translateService.currentLang;
  }
}
